import React from 'react';

import Link from 'eventbrite_design_system/link/Link';
import gettext from 'js-utils/gettext';

import SearchMap from './SearchMap';
import SearchMapDesktop from './SearchMapDesktop';
import SearchMapMobileWrapped from './SearchMapMobile';


/* Including this here until the experimental map is released. Then this should
be moved to SearchMapBase.js */
const SearchMapContext = ({currentPlace, enableNearmeSpa}) => {
    const locationTerm = currentPlace;
    const content = gettext('Showing results in %(locationTerm)s', {locationTerm});

    // TODO: Update copy on map when we are
    // showing low inventory search (point radius)
    // if (isLowInventory) {
    // }

    let nearmeLink = null;

    if (enableNearmeSpa) {
        nearmeLink = (<Link to="/nearme">{gettext('Explore events Near Me')}</Link>);
    }

    return (
        <div>
            <div className="eds-l-pad-top-2 eds-text-color--grey-500">{content}</div>
            {nearmeLink}
        </div>
    );
};

const SearchMapSplitter = (props) => {
    const {
        currentPlace,
        featureFlags,
        ...mapProps
    } = props;

    let nonInteractiveMobileSpacing = 'eds-l-pad-bot-6';

    let MapToShow = SearchMap;

    if (props.featureFlags.searchMapEnhancements) {
        nonInteractiveMobileSpacing = '';

        if (props.isMobile) {
            MapToShow = SearchMapMobileWrapped;
        } else {
            MapToShow = SearchMapDesktop;
        }
    }

    return (
        <div className={nonInteractiveMobileSpacing}>
            <MapToShow {...mapProps} />
        </div>
    );
};

export default SearchMapSplitter;
